import { render } from "./ModalPromoCode.vue?vue&type=template&id=c6e82b6e&scoped=true"
import script from "./ModalPromoCode.vue?vue&type=script&lang=js"
export * from "./ModalPromoCode.vue?vue&type=script&lang=js"

import "./ModalPromoCode.vue?vue&type=style&index=0&id=c6e82b6e&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e82b6e"]])

export default __exports__